import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../../../styles";
export const StyledSectionTitle = styled.span `
	font-size: ${Mi.fontSizeSubtitle};
	margin-bottom: ${Mi.spacer06};
`;
//# sourceMappingURL=SelectorSection.style.js.map